import { RichTextRenderer } from "~/components/RichTextRenderer";
import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";

interface NewsletterSectionProps {
  headline?: string;
  text?: string;
  inputPlaceholder?: string;
  submitLabel?: string;
  consentText?: string;
}

export default function NewsletterSection({
  headline = "Abonnieren Sie unseren Newsletter für Veranstaltungsplaner",
  text = "Bleiben Sie über unsere neuesten Angebote informiert.",
  inputPlaceholder = "Geben Sie Ihre E-Mail ein",
  submitLabel = "Abonnieren",
  consentText = "Mit dem Abonnieren stimmen Sie unserer Datenschutzerklärung zu.",
}: NewsletterSectionProps) {
  return (
    <section>
      <div className="flex flex-wrap items-start justify-between gap-8">
        {/* Left side: Text */}
        <div className="max-w-md">
          <h2 className="text-lg font-semibold">{headline}</h2>
          <RichTextRenderer additionalClasses="mt-1" richText={text} />
        </div>

        {/* Right side: Form */}
        <form className="flex flex-wrap items-start gap-3 max-w-md">
          <Input
            placeholder={inputPlaceholder}
            className="min-w-[250px]"
            type="email"
          />

          <Button size={"lg"} variant={"outline"}>
            {submitLabel}
          </Button>

          <a target="_blank" href="#" className="text-sm underline">
            {consentText}
          </a>
        </form>
      </div>
    </section>
  );
}
